export enum API {
  backoffice = 'agenda-backoffice',
  checklist = 'agenda-checklist',
  dealer = 'agenda-dealer',
  dealermedia = 'agenda-dealermedia',
  maintenance = 'agenda-maintenance',
  notifications = 'agenda-notifications',
  owners = 'agenda-owners',
  producer = 'agenda-producer',
  scheduling = 'agenda-scheduling',
  payments = 'agenda-payments',
  transformation = 'transformation',
  users = 'agenda-users',
  consumer = 'agenda-consumer'
};

export enum BFF {
  scheduling = 'scheduling',
}
